Apt.$set("versions", {"core":"1.8.76","debug":"2.0.0","internal":"0.3.2"});